import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PcmpFormSectionProps {
  id: string;
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function PcmpFormSection({
  id,
  title,
  description,
  action,
  children,
  className,
}: PcmpFormSectionProps) {
  return (
    <section
      aria-labelledby={id}
      className={cn('flex flex-col gap-4 rounded-xl border bg-card p-5 shadow-sm', className)}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex flex-col gap-1">
          <h2 id={id} className="text-lg font-semibold">
            {title}
          </h2>
          {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
